import { render, staticRenderFns } from "./trial_expiration.vue?vue&type=template&id=0b2ef8ce&scoped=true&"
import script from "./trial_expiration.vue?vue&type=script&lang=js&"
export * from "./trial_expiration.vue?vue&type=script&lang=js&"
import style0 from "./trial_expiration.vue?vue&type=style&index=0&id=0b2ef8ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2ef8ce",
  null
  
)

export default component.exports